var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"topOfContent"},[_vm._t("before"),(_vm.items)?_c('renderer',{attrs:{"result":_vm.items}}):_vm._t("default"),_c('ui-limit-pagination',{attrs:{"pagination":_vm.pagination,"url":_vm.url},on:{"input":_vm.handlePaginate}})],2)}
var staticRenderFns = []

export { render, staticRenderFns }